export const CART_IMPORT_EXPORT_FEATURE = 'cartImportExport';
